import { VIDEO_TYPE as defaultVideoTypes } from "../../sharedComponents/VideoPlayer";

const VIDEO_TYPE = {
	...defaultVideoTypes,
	CLOUDINARY: "Cloudinary",
};

export default VIDEO_TYPE;
export { VIDEO_TYPE };
